import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export async function getAllExtraDocs(callback) {
	firebaseRef
		.ref(
			'/kavtek_forms/' +
				PROJECT_CODE.projectCode +
				'/helloSignDocs/extrasList/'
		)
		.once('value', (snapshot) => {
			var extraListParentObj = snapshot.val();
			callback(extraListParentObj);
		});
}
